/* Zentrale Lieferdatum-Berechnung (einzige Quelle der Logik):
   Deadline = nächster Bestellschluss (global: Theme-Setting delivery_cutoff_time),
   Lieferdatum = Deadline + Tage (Varianten-Metafeld custom.delivery_days, Default 3).
   Sonntage werden bei Deadline und Lieferdatum übersprungen.
   Genutzt von nr-delivery-time-banner (PDP) und nr-cart-shipping (Warenkorb). */
window.nrDeliveryDate = function (cutoffStr, days) {
  var parts = String(cutoffStr || '10:30').split(':');
  var h = parseInt(parts[0], 10);
  var m = parseInt(parts[1] || '0', 10);
  if (isNaN(h)) h = 10;
  if (isNaN(m)) m = 30;

  var deadline = new Date();
  deadline.setHours(h, m, 0, 0);
  if (deadline.getTime() <= Date.now()) deadline.setDate(deadline.getDate() + 1);
  while (deadline.getDay() === 0) deadline.setDate(deadline.getDate() + 1);

  var d = parseInt(days, 10);
  if (isNaN(d) || d < 1) d = 3;
  var delivery = new Date(deadline.getTime());
  delivery.setDate(delivery.getDate() + d);
  while (delivery.getDay() === 0) delivery.setDate(delivery.getDate() + 1);

  return { deadline: deadline, delivery: delivery };
};
